// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__cpUTx","empty":"ModalGraph_empty__3ds77"};